// Vendor imports
const { createSelector } = require('reselect')
// Sibling imports
const allProviders = require('./providers')

const isVisible = createSelector(
  state => state.authModal,
  Boolean
)

const providers = createSelector(
  state => state.user.hasRollout('email_auth'),
  hasEmailAuth => (
    hasEmailAuth
    ? allProviders
    : allProviders.filter(provider => provider.id !== 'email')
  )
)

module.exports = {
  isVisible,
  providers
}
